/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import * as qs from 'qs';
import LeadDataService from '../services/lead-data.service';
import AppService from '../services/app.service';
import DocumentService from '../services/document.service';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    leadData: {},
    isEditTrade: false,
    isNewTrade: false,
    isDeleteDocument: false,
    isShowDocument: false,
    isShowNavigate: true,
    currentProgram: {},
    listTypes: {},
    appData: [],
    timetable : {},
    leadStatusFavorDefault: window.leadStatusFavorDefault || [],
    leadStatusFavorCustom: window.leadStatusFavorCustom || [],
    programs: [],
    documents: [],
    activeTab: 'sp_trades',
    tabs: [
      // {
      //   name: 'Comment',
      //   code: 'comment',
      //   isActive: true,
      // },
      // {
      //   name: 'Profile',
      //   code: 'profile',
      //   isActive: false,
      // },
      // {
      //   name: 'Transactions',
      //   code: 'deposits',
      //   isActive: false,
      // },
      {
        name: 'Documents',
        code: 'documents',
        isActive: false,
      },
      {
        name: 'Sp.Trades',
        code: 'sp_trades',
        isActive: false,
      }
    ],
  },
  mutations: {
    setter(state, object) {
      Object.entries(object).forEach(([key, value]) => {
        Vue.set(state, key, value);
      });
    },
  },
  actions: {
    getCall(query) {
     return LeadDataService.call(query)
    },
    getAppData({commit}) {
      let checkSession = [null, undefined, 'null', 'undefined']

      if (checkSession.includes(sessionStorage.appData)) {
        AppService.getAppData().then((response) => {
          console.log(response, 'getAppData');
          commit('setter', {appData: response.data});
          sessionStorage.appData = JSON.stringify(response.data);
        })
      } else {
        commit('setter', {appData: JSON.parse(sessionStorage.appData)});
      }
    },
    getLead({commit}, leadId) {
     return LeadDataService.getLead(leadId).then((response) => {
        commit('setter', {leadData: response.data});
      }).catch((error) => console.error(error));
    },
    sendRequest({state}, requestBody) {
      return axios.post(requestBody.url, qs.stringify(requestBody.data));
    },
    getPrograms({commit}, data) {
      LeadDataService.getPrograms(data).then((response) => {
        commit('setter', {programs: response.data.data})
      })
    },
    getDocuments({commit}, data) {
      DocumentService.execute(data).then((response) => {
        commit('setter', {documents: response.data.data})
      })
    },
    getTypesList({commit}) {
      LeadDataService.getTypesList().then((response) => {
        commit('setter', {listTypes: response.data.data})
      })
    }
  },
  getters: {}
});
